import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  node: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      color: theme.palette.primary.light,
      // was '& $bracket' (JSS self-reference to the .bracket rule); the bracket Box
      // is the only <div>-rendering child of this node Box, so '& > div' targets it
      // identically without relying on JSS-only class interpolation.
      '& > div': {
        border: `solid 2px ${theme.palette.primary.light}`,
        borderRight: 'none',
      }
    }
  },
  bracket: {
    width: '10px',
    marginLeft: '24px',
    border: 'solid 1px #eee',
    borderRight: 'none',
  },
  searchContainer: {
    width: '70%',
    justifySelf: 'center',
    padding: theme.spacing(1, 1, 1, 1),
  },
  search: {
    position: 'relative',
    borderRadius: `${theme.shape.borderRadius}px`,
    borderColor: 'black',
    backgroundColor: 'white',
    width: '100%',
  },
  searchIcon: {
    pointerEvents: 'none',
  },
  searchResult: {
    width: '100%',
    maxHeight: '64vh',
    overflow: 'auto',
    padding: '1em 2em',
    '& table': {
      lineHeight: 'normal',
      width: '100%',
      height: '100%',
      fontSize: '16px',
      '& tr': {
        borderSpacing: '0px', padding: '0px',
        '& td': {
          // padding: '0px 16px',
        },
        '& td[show-border=true]': {
          // borderLeft: 'solid 1px #c8c8c8',
          // borderRadius: '5px',
        },
        '& td:hover': {
          cursor: 'pointer',
          // backgroundColor: '#f5f5f5',
        },
      }
    }
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  provisionTreeContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',
  },
  checkboxTreeContainer: {
    width: '100%',
    minHeight: 320,
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '10px',
  },
});
